import {Alert, CircularProgress, SimpleGrid} from "@chakra-ui/react";
import Post from "./Post";
import InfiniteScroll from "react-infinite-scroller";
import useSWRInfinite from "swr/infinite";
import Error from "./Error";

function Posts({username}) {
    const getKey = (pageIndex, previousPageData) => {
        // reached the end
        if (previousPageData && !previousPageData?.posts?.length && previousPageData?.posts?.length < 12) return null
        const url = "/posts?id=" + username 
        // first page, we don't have `previousPageData`
        if (pageIndex === 0) return url
        // add the cursor to the API endpoint
        return url + `&pagination_token=${previousPageData.pagination_token}`
    }
    const {data, error, isLoading, size, setSize} = useSWRInfinite(getKey)
    const posts = data ? [].concat(...data.filter(page => page?.posts).map(page => page.posts)) : [];
    const hasMore = data && data[data.length - 1]?.posts?.length === 12;
    const isLoadingMore = isLoading || (size > 0 && data && typeof data[size - 1] === "undefined");
    const loadMore = () => {
        if (!isLoadingMore && hasMore) {
            setSize(size + 1);
        }
    };

    if (isLoading && size === 1) return <CircularProgress isIndeterminate color='green.300'/>
    if (error) return <Error/>
    if (posts.length === 0) return (<Alert status={"info"}>@{username} has no posts</Alert>)

    return (
        <InfiniteScroll
            pageStart={0}
            hasMore={hasMore}
            initialLoad={false}
            loadMore={loadMore}
            loader={<div className="loader" key={0}>Loading ...</div>}
        >
            <SimpleGrid columns={3} spacing={{base: 3, md: 6}}>
                {
                    posts.map(post => (
                        <Post key={post?.node?.id ?? post.id} post={post?.node ?? post}/>
                    ))
                }
            </SimpleGrid>
        </InfiniteScroll>
    );
}

export default Posts